import { PressableAltoIcon } from '@alto/design-system';
import { type AddOnOtc } from '@alto/scriptdash/alto/patient_app/add_ons/types/v1/add_on_otc';
import React from 'react';

export type EditMedicationItemProps = {
  readonly essential: AddOnOtc | undefined;
  readonly editMedicationOnPress: () => void;
  readonly onChangeEssential?: () => void;
};

export const EditMedicationItemButton = ({
  essential,
  editMedicationOnPress,
  onChangeEssential,
}: EditMedicationItemProps) => {
  const handleEdit = () => {
    if (essential && onChangeEssential) {
      onChangeEssential();
    } else {
      editMedicationOnPress();
    }
  };

  return (
    <PressableAltoIcon
      name="edit"
      type="grey"
      accessibilityLabel="Edit item"
      onPress={handleEdit}
    />
  );
};
